export default function AdjustmentEmptyCatalog() {

    return (
        <div className="py-8 text-center">
            <p className="text-sm text-gray-500">Nenhum item de ajuste se aplica a este serviço.</p>
        </div>
    );
}
